import { Text, Heading } from "../../../../components/common/typography";
import type { ProductVariantDto } from "../../../../api";

type SpecsRow = {
  label: string;
  value: string;
  isLink?: boolean;
};

export function ProductVariantSpecs({
  product,
}: {
  product: ProductVariantDto;
}) {
  const rows: SpecsRow[] = [];

  if (product.model) {
    rows.push({ label: "Model", value: product.model });
  }
  if (product.condition?.name) {
    rows.push({ label: "Condition", value: product.condition.name });
  }
  if (product.notes) {
    rows.push({ label: "Variant Notes", value: product.notes });
  }

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="pt-4 border-t border-uiSecondary">
      <Heading variant="h3" tone="dark" className="mb-3">
        Variant Specifications
      </Heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {rows.map((row) => (
          <div key={row.label} className="flex flex-col gap-0.5">
            <Text variant="bodyLg" tone="dark" className="mb-1">
              {row.label}
            </Text>
            {row.isLink ? (
              <a
                href={row.value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline break-all"
              >
                {row.value}
              </a>
            ) : (
              <Text variant="body" tone="body">
                {row.value}
              </Text>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
